@if (!passwordUpdated) {
  <div class="d-flex flex-column gap-16 gap-16-768 background-white change-password-card px-24-768 pt-24-768">
    <div class="icon-circle d-flex align-items-center justify-content-center p-10">
      <img src="assets/images/key-outline.svg" alt="key" class="change-password-icon">
    </div>
    <div class="d-flex flex-column gap-32-768">
      <div class="d-flex flex-column gap-32 gap-32-768">
        <div class="d-flex flex-column gap-24 gap-24-768">
          <div class="d-flex flex-column gap-6 gap-768">
            <h2 class="heading2-768 font-bold heading2 text-black">Change your password</h2>
            <p class="paragraph-Medium paragraph-large-768 open-sans txt-charcoalGrey500">Choose a strong, unique password to help keep your account secure.</p>
          </div>
          <div class="d-flex flex-column gap-16 gap-16-768">
            <div class="d-flex flex-column gap-8 gap-8-768">
              <label class="font-semibold paragraph-xsmall-768 heading6">Current password</label>
              <app-custom-bx-input [control]="oldPasswordControl" id="inlineOldPassword"
                type="password" [isShowError]="false">
              </app-custom-bx-input>
            </div>
            <div class="d-flex flex-column gap-10 gap-10-768">
              <div class="d-flex flex-column gap-8 gap-8-768" [class.input-error-border]="newPasswordControl?.invalid && (newPasswordControl?.touched || newPasswordControl?.dirty)">
                <label class="font-semibold paragraph-xsmall-768 heading6">New password</label>
                <app-custom-bx-input [control]="newPasswordControl" id="inlineNewPassword"
                  type="password" [isShowError]="false" [firstErrorOnly]="true">
                </app-custom-bx-input>
              </div>
              @if ((newPasswordControl?.touched || newPasswordControl?.dirty) && newPasswordControl?.invalid) {
                <div
                  class="password-policy-box gap-12 round-8 p-15 p-15-768"
                  [class.password-policy-error]="newPasswordControl?.invalid">
                  <app-password-validation-status [password]="newPasswordControl?.value">
                  </app-password-validation-status>
                </div>
              }
            </div>
            <div class="d-flex flex-column gap-8 gap-8-768" [class.input-error-border]="confirmPasswordControl?.invalid && (confirmPasswordControl?.touched || confirmPasswordControl?.dirty)">
              <label class="font-semibold paragraph-xsmall-768 heading6">Confirm new password</label>
              <app-custom-bx-input [control]="confirmPasswordControl" id="inlineConfirmPassword"
                type="password" [isShowError]="false" [firstErrorOnly]="true">
              </app-custom-bx-input>
            </div>
          </div>
        </div>
        <div class="update-btn-wrapper mobile-btn p-24">
          <button class="btn-primary-red paragraph-extra-Medium-768 paragraph-extra-Medium font-semibold"
            [disabled]="form.invalid"
          (click)="changePassword()">Update password</button>
        </div>
      </div>
      <div class="update-btn-wrapper p-24">
        <button class="btn-primary-red paragraph-extra-Medium-768 paragraph-extra-Medium font-semibold"
          [disabled]="form.invalid"
        (click)="changePassword()">Update password</button>
      </div>
    </div>
  </div>
}

@if (passwordUpdated) {
  <div class="d-flex flex-column align-items-center justify-content-center success-container pt-24 px-24 pb-24">
    <div class="d-flex flex-column gap-32 gap-32-768 background-white success-card p-24-768">
      <div class="d-flex flex-column gap-16 gap-16-768">
        <div class="success-icon-circle d-flex align-items-center justify-content-center">
          <img src="assets/images/tick.svg" alt="success" class="success-icon">
        </div>
        <div class="d-flex flex-column gap-6 gap-6-768">
          <h2 class="heading2-768 font-bold heading2 text-black no-wrap">Password updated successfully</h2>
          <p class="paragraph-Medium paragraph-large-768 open-sans txt-charcoalGrey500 no-wrap">Sign in with your new password next time.</p>
        </div>
        <div class="done-btn-wrapper p-24">
          <button class="btn-primary-red paragraph-extra-Medium-768 font-semibold"
          (click)="done()">Done</button>
        </div>
      </div>
    </div>
  </div>
}
